import './style.scss'

import RichText from 'components/RichText'
import Images from 'components/Images'
import TeaserGrid from 'components/TeaserGrid'
import Accordion from 'components/Accordion'
import LinkGroup from 'components/LinkGroup'
import Form from 'components/Form/Form'
import ContentList from 'components/ContentList'
import DownloadsList from 'components/DownloadsList'
import VideoGrid from 'components/VideoGrid'
import ContactSection from 'components/ContactSection'
import GalleryWrapper from 'components/GalleryWrapper'

export default {
  name: 'FlexContent',
  props: ['componentData'],
  render (h) {
    const { componentData } = this
    return (
      <div class='FlexContent'>
        { componentData.map(c => renderLayout(h, c)) }
      </div>
    )
  }
}

function renderLayout (h, component) {
  const layoutType = component.acf_fc_layout
  if (layoutType === 'text') {
    return <div class={`FlexContent__item FlexContent__item--${layoutType}`}><RichText content={component.rich_text} /></div>
  } else if (layoutType === 'images') {
    return <div class={`FlexContent__item FlexContent__item--${layoutType}`}><Images componentData={component.images} /></div>
  } else if (layoutType === 'teaser_grid' || layoutType === 'image_teaser_grid') {
    return <div class={`FlexContent__item FlexContent__item--${layoutType}`}><TeaserGrid componentData={component.teasers} addLinks={component.add_links} /></div>
  } else if (layoutType === 'accordion') {
    return <div class={`FlexContent__item FlexContent__item--${layoutType}`}><Accordion sections={component.accordion_items} /></div>
  } else if (layoutType === 'link_group') {
    return <div class={`FlexContent__item FlexContent__item--${layoutType}`}><LinkGroup componentData={component.links} /></div>
  } else if (layoutType === 'form') {
    return <div class={`FlexContent__item FlexContent__item--${layoutType}`}>
      <Form buttonText={component.button_text}
        formEndpoint={component.form_endpoint}
        formFields={component.form_fields}
        showConfirmation={component.show_confirmation}
        confirmationTitle={component.confirmation_title}
        confirmationText={component.confirmation_text}
        gdpr={component.gdpr}
        showNewsletterSignup={component.show_newsletter_signup}
        showFeedbackForm={component.show_feedback_form}
        feedbackForm={component.feedback_form}
      />
    </div>
  } else if (layoutType === 'content_list') {
    return <div class={`FlexContent__item FlexContent__item--${layoutType}`}><ContentList componentData={component.list_sections} /></div>
  } else if (layoutType === 'downloads_list') {
    return <div class={`FlexContent__item FlexContent__item--${layoutType}`}><DownloadsList componentData={component.downloads_section} /></div>
  } else if (layoutType === 'video_grid') {
    return <div class={`FlexContent__item FlexContent__item--${layoutType}`}><VideoGrid componentData={component.video_grid_items} /></div>
  } else if (layoutType === 'contact_section') {
    return <div class={`FlexContent__item FlexContent__item--${layoutType}`}><ContactSection title={component.contact_section_title} items={component.contact_items} /></div>
  } else if (layoutType === 'image_gallery') {
    return <div class={`FlexContent__item FlexContent__item--${layoutType}`}>
      <GalleryWrapper componentData={component.images} />
    </div>
  }
}



// WEBPACK FOOTER //
// ./client/components/FlexContent/index.js